<template>

	<div class="bio">
		<div class="photo" v-if="bio.photo">
			<div class="frame" v-if="bio.photo.path" :style="'background-image: url(' + bio.photo.path + ');'"></div>
		</div>
		<div class="bio-details">
			<h3 class="bio-name">
				{{ bio.name }}
			</h3>
			<div class="position">
				{{ bio.position }}
			</div>
			<PrimaryCTA v-if="bio.cta" :linkText="bio.cta.linkText" :linkURL="bio.cta.linkURL"></PrimaryCTA>
		</div>
		
		<div class="more-info-content" v-if="bio.moreInfoContent">
			<div v-html="bio.moreInfoContent"></div>
			<PrimaryCTA v-if="bio.cta" :linkText="bio.cta.linkText" :linkURL="bio.cta.linkURL"></PrimaryCTA>
		</div>
		
		<div class="more-info"  v-if="bio.moreInfoContent">
			<svg version="1.1" class="icon-info" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 46 100" xml:space="preserve">
				<path class="st0" d="M34.7,1.8c6.5,0,9.7,4.4,9.7,9.4c0,6.3-5.6,12.1-12.9,12.1c-6.1,0-9.7-3.6-9.5-9.6C22,8.7,26.2,1.8,34.7,1.8z
					M14.9,98.2c-5.1,0-8.8-3.1-5.3-17l5.8-24.5c1-3.9,1.2-5.5,0-5.5c-1.5,0-8.1,2.7-12.1,5.4l-2.5-4.2c12.4-10.5,26.6-16.7,32.8-16.7
					c5.1,0,5.9,6.1,3.4,15.6L30.3,77c-1.2,4.6-0.7,6.1,0.5,6.1c1.5,0,6.5-1.9,11.5-5.8l2.9,3.9C33.1,93.4,19.9,98.2,14.9,98.2z"/>
			</svg>
		</div>
		
		<div class="close-info">
			<svg class="icon-close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 212.982 212.982" xml:space="preserve">
				<g>
					<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312
						c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312
						l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937
						c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z"/>
				</g>
			</svg>
		</div>
	</div>
	
</template>

<script>

	import PrimaryCTA from '../Global/PrimaryCTA.vue';
	
	export default {
		name: 'Bio',
		
		props: ['bio'],
		
		components: {
			PrimaryCTA
		}
	}
	
</script>